import { api, headersConfig } from "../../services/api";

const service_path = '/quotes.php';
const messages_path = '/quote-messages.php';

export async function getQuotes(filters = {}) {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== '' && value != null) {
            params.set(key, String(value));
        }
    });
    const query = params.toString();
    const response = await api.get(query ? `${service_path}?${query}` : service_path, headersConfig);

    return response;
};

export async function getQuoteDetails(id) {

    const response = await api.get(`${service_path}?id=` + id, headersConfig);

    return response;
};

export async function createQuote(payload) {

    const response = await api.post(service_path, payload, headersConfig);

    return response;
};

export async function approveQuote(id, productId) {

    const payload = { approve: true, id };
    if (productId) {
        payload.product_id = productId;
    }

    const response = await api.patch(service_path, payload, headersConfig);

    return response;
};

export async function getQuoteMessages(quoteId) {

    const response = await api.get(`${messages_path}?quote_id=${quoteId}`, headersConfig);

    return response;
};

export async function postQuoteMessage(payload) {

    const response = await api.post(messages_path, payload, headersConfig);

    return response;
};


